import { IReduxState } from 'types';

export const getUI = (state: IReduxState) => state.ui;
export const getIsOpenedFromCloseModal = (state: IReduxState) => getUI(state).isOpenedFromCloseModal;
export const getPreviewImage = (state: IReduxState) => getUI(state).previewImage;
